import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { currentAppToken } from '../auth/app-token';

@Injectable({
  providedIn: 'root',
})
export class HttpHelperService {
  public getHttpHeaders(uploadFile: boolean = false, customHeaders: Record<string, string> = {}): HttpHeaders {
    let headers: HttpHeaders = new HttpHeaders();

    if (!uploadFile) {
      headers = headers.set('Accept', 'application/json');
      headers = headers.set('Content-Type', 'application/json');
    }

    Object.entries(customHeaders).forEach(([key, value]: [string, string]) => {
      headers = headers.set(key.toString(), value.toString());
    });

    const token: string = currentAppToken();
    if (token) {
      headers = headers.set('Authorization', 'Bearer ' + token);
    } else {
      const registerData: Record<string, any> = JSON.parse(localStorage.getItem('register_data') || '{}');
      if (registerData?.auth) {
        headers = headers.set('Authorization', 'Bearer ' + registerData.auth.token);
      }
    }
    return headers;
  }

  public getRegistrationHeaders(): HttpHeaders {
    const registerData: Record<string, { token: string }> = JSON.parse(localStorage.getItem('register_data') || '{}');
    return new HttpHeaders({
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + registerData.auth.token,
    });
  }

  public getMovieSubtitleEndpointHeader(): HttpHeaders {
    const token: string = currentAppToken();
    return new HttpHeaders({
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });
  }
}
